import { Toaster as Sonner, toast, type ToasterProps } from "sonner";

/**
 * Toast host styled like the original `.toast` pill: dark panel, gold
 * hairline, centered near the bottom above the navigation.
 */
function Toaster(props: ToasterProps): React.JSX.Element {
  return (
    <Sonner
      theme="dark"
      position="bottom-center"
      offset={{ bottom: 96 }}
      mobileOffset={{ bottom: 96 }}
      duration={2600}
      gap={8}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "fr-toast",
          title: "fr-toast-title",
          description: "fr-toast-desc",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
